import { SortOrder } from '@/enums';
import { axiosClient } from '@/hooks';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchVillages = createAsyncThunk(
  'villages/fetchVillages',
  async (
    {
      page,
      limit,
      orderBy,
      sortOrder,
      search
    }: {
      page: number;
      limit: number;
      orderBy?: string;
      sortOrder?: SortOrder;
      search?: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosClient.get(`/villages`, {
        params: {
          page,
          limit,
          ...(orderBy && { orderBy }),
          ...(sortOrder && { sortOrder }),
          ...(search && { search })
        }
      });
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchOneVillage = createAsyncThunk(
  'villages/fetchOneVillage',
  async (villageId: string, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(`/villages/${villageId}`);
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const fetchVillagesByCell = createAsyncThunk(
  'villages/fetchVillagesByCell',
  async (cellId: string, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(`/cells/${cellId}/villages`);
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);
